import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import WebContentSurvey from './pages/WebContentSurvey';
import Header from './components/Header';
import NotFound from './pages/NotFound';
import WebContentSurveyEndPage from './pages/WebContentSurveyEndPage';

function App() {
    return (
        <Router>
            <Header />
            <Routes>
                <Route path="/" element={<Navigate to="/wc" />} />
                <Route path="/wc" element={<WebContentSurvey />} />
                <Route path="/wc-end" element={<WebContentSurveyEndPage />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Router>
    );
}

export default App;